
(function () {
  'use strict';

  if (window.BNHeartSound) return;

  var DEAD = { closed: 1, interrupted: 1 };
  var audioCtx = null;
  var unlocked = false;
  var installed = false;

  function ctx() {
    if (audioCtx && !DEAD[audioCtx.state]) return audioCtx;
    if (audioCtx && DEAD[audioCtx.state]) audioCtx = null;
    var Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    try { audioCtx = new Ctor(); } catch (e) { audioCtx = null; }
    return audioCtx;
  }

  function unlock() {
    if (unlocked) return;
    unlocked = true;
    var c = ctx();
    if (!c) return;
    try {
      var p = c.resume && c.resume();
      var rate = c.sampleRate || 22050;
      var buf = c.createBuffer(1, Math.floor(rate * 0.4), rate);
      var src = c.createBufferSource();
      src.buffer = buf;
      src.connect(c.destination);
      if (src.start) src.start(0); else src.noteOn(0);
      if (p && typeof p.then === 'function') p.then(function () {}, function () {});
    } catch (e) {   }
  }

  function play(build) {
    try {
      var c = ctx();
      if (!c) return;
      var attempts = 0;
      var schedule = function () {
        if (c.state !== 'running') {
          if (++attempts < 5) setTimeout(schedule, 30);
          return;
        }
        var t = c.currentTime + 0.02;
        try { build(c, t); } catch (e) {   }
      };
      var p = c.resume && c.resume();
      if (p && typeof p.then === 'function') p.then(schedule, schedule);
      else schedule();
    } catch (e) {   }
  }

  function add() {
    if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {   } }
    play(function (c, t) {
      var o1 = c.createOscillator(), g1 = c.createGain();
      o1.connect(g1); g1.connect(c.destination);
      o1.type = 'sine'; o1.frequency.value = 880;
      g1.gain.setValueAtTime(0.0001, t);
      g1.gain.linearRampToValueAtTime(0.10, t + 0.005);
      g1.gain.exponentialRampToValueAtTime(0.001, t + 0.08);
      o1.start(t); o1.stop(t + 0.09);
      var o2 = c.createOscillator(), g2 = c.createGain();
      o2.connect(g2); g2.connect(c.destination);
      o2.type = 'sine'; o2.frequency.value = 1320;
      g2.gain.setValueAtTime(0.0001, t + 0.07);
      g2.gain.linearRampToValueAtTime(0.08, t + 0.075);
      g2.gain.exponentialRampToValueAtTime(0.001, t + 0.15);
      o2.start(t + 0.07); o2.stop(t + 0.16);
    });
  }

  function remove() {
    if (navigator.vibrate) { try { navigator.vibrate([5, 30, 5]); } catch (e) {   } }
    play(function (c, t) {
      var o = c.createOscillator(), g = c.createGain();
      o.connect(g); g.connect(c.destination);
      o.type = 'sine';
      o.frequency.setValueAtTime(660, t);
      o.frequency.exponentialRampToValueAtTime(330, t + 0.12);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(0.08, t + 0.005);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.12);
      o.start(t); o.stop(t + 0.13);
    });
  }

  function teardown() {
    if (audioCtx && audioCtx.state !== 'closed') { try { audioCtx.close(); } catch (e) {   } }
    audioCtx = null;
    unlocked = false;
  }

  function install() {
    if (installed) return;
    installed = true;
    var cfg = window.__wishlist;
    if (!(cfg && cfg.loggedIn && cfg.customerId)) return;
    var events = ['pointerdown', 'touchstart', 'keydown', 'click'];
    var handler = function () {
      unlock();
      for (var i = 0; i < events.length; i++) document.removeEventListener(events[i], handler, true);
    };
    for (var j = 0; j < events.length; j++) {
      document.addEventListener(events[j], handler, { once: true, capture: true, passive: true });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && audioCtx && audioCtx.state === 'suspended') {
        try { audioCtx.resume(); } catch (e) {   }
      }
    });
    window.addEventListener('pagehide', teardown);
  }

  window.BNHeartSound = { add: add, remove: remove, unlock: unlock, teardown: teardown };
  install();
}());
